import { BLOCKING_FIELDS, RECOMMENDED_FIELDS } from '../../../utils/missingFieldsDetection';
import { SELECT_OPTION_VALUES } from '../../../utils/job-field-i18n';

export type FieldType = 'text' | 'number' | 'tags' | 'textarea' | 'select';

export interface FieldConfig {
  name: string;
  type: FieldType;
  placeholder?: string;
  label?: string;
}

const FIELD_TYPE_MAP: Record<string, FieldType> = {
  'Years of Experience': 'number',
  'Skills': 'tags',
  'Mission Role in Job': 'textarea',
  'Company Description': 'textarea',
  'Remote Policy': 'select',
  'Contract Type': 'select',
  'Required Degree': 'select'
} as const;

export const getFieldConfig = (fieldName: string): FieldConfig => {
  const type = FIELD_TYPE_MAP[fieldName] || 'text';
  
  return {
    name: fieldName,
    type,
    placeholder: `Enter ${fieldName.toLowerCase()}`,
    label: fieldName,
  };
};

export const isTagField = (fieldName: string): boolean => {
  return fieldName === 'Skills';
};

export const isNumberField = (fieldName: string): boolean => {
  return fieldName === 'Years of Experience';
};

export const isTextareaField = (fieldName: string): boolean => {
  return fieldName === 'Mission Role in Job' || fieldName === 'Company Description';
};

export const isSelectField = (fieldName: string): boolean => {
  return fieldName === 'Remote Policy' || fieldName === 'Contract Type' || fieldName === 'Required Degree';
};
/** @deprecated Use getTranslatedSelectOptions from job-field-i18n at the presentation layer. */
export const getSelectOptions = (fieldName: string): { value: string; label: string }[] => {
  const values = SELECT_OPTION_VALUES[fieldName] ?? [];
  return values.map((value) => ({ value, label: value }));
};


export { BLOCKING_FIELDS, RECOMMENDED_FIELDS };
export const ALL_JOB_FIELDS = [...BLOCKING_FIELDS, ...RECOMMENDED_FIELDS] as const;
